/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserMutationResponse, UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUser";

function getUsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserUrl(userId: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserPathParams["permission"]) {
  const res = { method: 'POST', url: `/admin/user/${userId}/permissions/${permission}/allow` as const }  
  return res
}

/**
 * @summary Allow a permission for a user
 * {@link /admin/user/:userId/permissions/:permission/allow}
 */
export async function usersAuthzAPIAdminPermissionsWriteAllowPermissionToUser(userId: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserPathParams["permission"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getUsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserUrl(userId, permission).url.toString(), ... requestConfig })  
  return res.data
}